import React from 'react';
import styled from 'styled-components';
import { Box, Button, Flex, Text } from 'core/components';
import { formatDateTime, DEFAULT_DATETIME_FORMAT_WITH_SECONDS } from 'core/util/dateUtils';
import CopyToClipboardButton from 'app/components/CopyToClipboardButton';
import CommentAvatar from './CommentAvatar';

const Row = styled(Flex)`
  &:hover {
    background: ${({ theme }) => theme.colors.appBackground};
  }
`;

/** Comment's thread look: the author's avatar, name and time, the copy button and controls, then the text or the editor. */
const CommentThreadRow = ({ id, name, comment, cdate, controls, editor }) => (
  <Row id={`comment-${id}`} role="listitem" gap="10px" px="12px" py="10px" borderRadius={6}>
    <CommentAvatar name={name} />
    <Box flex="1 1 auto" minWidth={0}>
      <Flex alignItems="center" justifyContent="space-between" gap={1}>
        <Flex alignItems="baseline" gap={1} minWidth={0}>
          <Text fontWeight="medium">{name}</Text>
          <Text small muted title={formatDateTime(cdate, DEFAULT_DATETIME_FORMAT_WITH_SECONDS)}>
            {formatDateTime(cdate)}
          </Text>
        </Flex>
        <Flex alignItems="center" gap="2px" flex="0 0 auto">
          <CopyToClipboardButton text={comment} intent="none">
            <Button minimal small icon="clipboard" title="Copy comment" ariaLabel="Copy comment" />
          </CopyToClipboardButton>
          {!editor && controls}
        </Flex>
      </Flex>
      {editor || (
        <Box mt="2px" pl={2}>
          <Text whiteSpace="pre-wrap" wordBreak="break-word">
            {comment}
          </Text>
        </Box>
      )}
    </Box>
  </Row>
);

export default CommentThreadRow;
